// Mock for react-native-maps on web platform
import React from 'react';
import { View, Text } from 'react-native';

// Mock MapView component
const MapView = (props) => {
  return (
    <View style={[{
      height: 300,
      backgroundColor: '#f0f0f0',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 8,
    }, props.style]}>
      <Text style={{ color: '#666', fontSize: 16 }}>
        Maps not available on web
      </Text>
      <Text style={{ color: '#666', fontSize: 12, marginTop: 5 }}>
        Please use mobile app for map features
      </Text>
    </View>
  );
};

// Mock Marker component
const Marker = () => null;

// Mock other components that might be used
const PROVIDER_GOOGLE = 'google';
const PROVIDER_DEFAULT = 'default';

export default MapView;
export {
  Marker,
  PROVIDER_GOOGLE,
  PROVIDER_DEFAULT,
};